import useGetEligibleServicesQuery from '@/modules/transaction/queries/useGetEligibleServices.query';

import useEligibleServicesFormatter from './useEligibleServicesFormatter';

const useEligibleServices = (policyId?: number | string) => {
  const { data, isLoading, isSuccess } = useGetEligibleServicesQuery(policyId);
  const formattedData = useEligibleServicesFormatter(data);

  return { data: formattedData, isLoading, isSuccess };
};

export default useEligibleServices;
